module.exports = __webpack_public_path__ + "img/right1.d960e775.svg";